<template>
  <fragment>
    <aside ref="drawer" class="drawer drawer--modal">
      <slot :closeDrawer="close" v-bind:close="close"/>
    </aside>
    <div ref="scrim" class="scrim" @click="close"/>
  </fragment>
</template>

<script>
export default {
  name: 't-navigation-drawer',
  methods: {
    open () {
      this.$refs.drawer.classList.add('drawer--open')
    },
    close () {
      this.$refs.drawer.classList.remove('drawer--open')
    }
  },
  beforeDestroy () {
    this.close()
    this.$refs.drawer.remove()
    this.$refs.scrim.remove()
  }
}
</script>

<style lang="scss" scoped>
$drawer-width: 256px;

.drawer {
  backdrop-filter: blur(2px);
  opacity: 0;
  border-color: rgba(0, 0, 0, .12);
  padding-top: 24px;
  border-radius: 0 0 0 0;
  z-index: 6;
  width: $drawer-width;
  flex-direction: column;
  flex-shrink: 0;
  box-sizing: border-box;
  height: 100%;
  border-right-width: 1px;
  border-right-style: solid;
  overflow: hidden;
  left: 0;
  top: 0;
  right: auto;
  position: fixed;
  transition: opacity 200ms cubic-bezier(.4, 0, 1, 1), transform 200ms cubic-bezier(.4, 0, 1, 1);
  transform: translateX(-100vw);

  &--modal {
    &:before {
      content: '';
      background-color: var(--header);
      opacity: 0.9;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: -1;
    }

    box-shadow: 0 8px 10px -5px rgba(0, 0, 0, .2), 0 16px 24px 2px rgba(0, 0, 0, .14), 0 6px 30px 5px rgba(0, 0, 0, .12);

    + .scrim {
      transition: opacity 200ms cubic-bezier(.4, 0, 1, 1);
      opacity: 0;
    }
  }

  &--open {
    transition: opacity 250ms cubic-bezier(0, 0, .2, 1), transform 250ms cubic-bezier(0, 0, .2, 1);
    transform: translateX(0);
    display: flex;
    opacity: 1;

    + .scrim {
      transition: opacity 250ms cubic-bezier(0, 0, .2, 1);
      display: block;
      opacity: 1;
      pointer-events: all;
    }
  }
}

.scrim {
  background-color: var(--scrim);
  position: fixed;
  pointer-events: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
}
</style>
